<template>
  <el-container class="address-bookLayout">
    <el-header class="nav-container" :height="isMobile ? 'auto' : '60px'">
      <navbar nav-index="/addressBook" @nav-items-click="navClick" />
    </el-header>
    <el-container>
      <sidebar :items="addressBookRouters" class="sidebar-container" />

      <el-main id="addressBook-main-container" style="padding: 0;">
        <app-main />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { Navbar, AppMain, Sidebar } from "./components";
import { mapGetters, mapState } from "vuex";

export default {
  name: "AddressBookLayout",

  components: {
    Navbar,
    Sidebar,
    AppMain,
  },

  data() {
    return {};
  },

  computed: {
    ...mapState(["isMobile"]),
    ...mapGetters(["addressBookRouters"]),
  },

  methods: {
    navClick(index) {},
  },
};
</script>

<style lang="scss" scoped>
@import "./styles/common.scss";

@media screen and (max-width: 768px) {
  .address-bookLayout {
    .nav-container {
      z-index: 10000 !important;
    }
    .addressBook-main-container {
      width: 100vw !important;
    }
  }
}
@media screen and (min-width: 769px) {
  .nav-container {
    min-width: 1200px;
  }
}
.el-container {
  min-height: 0;
  height: 100%;
}

.nav-container {
  padding: 0;
  box-shadow: 0px 1px 2px #dbdbdb;
  z-index: 100;
  min-width: 1200px;
}
</style>
